<template>
    <div class="finder" :class="find ? 'active' : ''">
        <div class="finder-action">
            <input type="text" class="finder-input" placeholder="Buscar" ref="finderInput" @keyup="writing">
            <a href="#!" class="finder-cancel" style="display: inline-flex;"
                @click.prevent="finding(false)">
                <icon-cancel />
            </a>
        </div>
        <a href="#!" class="finder-search"
            @click.prevent="finding(true)">
            <icon-find />
        </a>
    </div>
</template>

<script>
import IconFind from '@/components/Icons/Find.vue'
import IconCancel from '@/components/Icons/Cancel.vue'

export default {
    name: 'finder',
    components: {
        IconFind,
        IconCancel
    },
    data() {
        return {
            find: false
        }
    },
    methods: {
        finding(find) {
            this.find = find
            if (find) this.$refs.finderInput.focus()
            else this.$refs.finderInput.blur()
        },
        writing(input) {
            this.$emit('keyup', input)
        }
    }
}
</script>
